import { render, staticRenderFns } from "./CardInformativa.vue?vue&type=template&id=c08c74ec&scoped=true&"
import script from "./CardInformativa.vue?vue&type=script&lang=ts&"
export * from "./CardInformativa.vue?vue&type=script&lang=ts&"
import style0 from "./CardInformativa.vue?vue&type=style&index=0&id=c08c74ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08c74ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c08c74ec', component.options)
    } else {
      api.reload('c08c74ec', component.options)
    }
    module.hot.accept("./CardInformativa.vue?vue&type=template&id=c08c74ec&scoped=true&", function () {
      api.rerender('c08c74ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiApp/reusables/CardInformativa.vue"
export default component.exports